<template>
  <div>
    <article class="box" style="margin-top:25px;">
      <div class="columns is-mobile is-centered">
        <div class="column is-offset-5">
          <img class="team_logo" :src="team_logo">
          <h1 class="title has-text-left has-text-weight-bold is-uppercase">{{team_name}} </h1>
        </div>
      </div>
      <form v-on:submit="updateRoster">
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>LW</th>
                <th>C</th>
                <th>RW</th>
                <th>LD</th>
                <th>RD</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in 4">
                <td >{{n}}</td>
                <td  v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd" v-for="item in Roster" v-if="n==item.line_number && item.position=== 'LW'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value">
                          {{playerOption.text}}
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
                <td v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd"  v-for="item in Roster" v-if="n==item.line_number && item.position=== 'C'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value">
                          {{playerOption.text}}
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
                <td v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd"  v-for="item in Roster" v-if="n==item.line_number && item.position=== 'RW'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value">
                          {{playerOption.text}}
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
                <td v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd"  v-for="item in Roster" v-if="n==item.line_number && item.position=== 'LD'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value" >
                          {{playerOption.text}}
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
                <td v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd"  v-for="item in Roster" v-if="n==item.line_number && item.position=== 'RD'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value" >
                          {{playerOption.text}} 
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table">
            <thead>
              <th>#</th>
              <th>Starting Goal Tender</th>
              <th>Backup Goal Tender</th>
              <th>Emergency Goal Tender</th>
              <th></th>
              <th></th>
              <th></th>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd" v-for="item in Roster" v-if="item.line_number==5 && item.position=== 'GT'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value" >
                          {{playerOption.text}}
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
                <td  v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd" v-for="item in Roster" v-if="item.line_number==5 && item.position=== 'BKPGT'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value">
                          {{playerOption.text}}
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
                <td v-bind:class="{'unverified': item.is_verified == 0,  'verified': item.is_verified != 0}" class="colourdtd" v-for="item in Roster" v-if="item.line_number==5 && item.position=== 'EMGGT'" v-bind:key="item.id">
                  <p class="control">
                    <span   class="select">
                      <select v-model="item.p_id" :change="updateRoster(item,item.p_id)">
                        <option v-for="playerOption in playerOptions " v-bind:value="playerOption.value" >
                          {{playerOption.text}}
                        </option>
                      </select>
                    </span>
                  </p>
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <p class="control" style="margin-top:20px">
            <button class="button is-medium is-primary" v-on:click="generateRoster">Clone Template Roster</button>
            <button class="button is-medium is-success" v-on:click="validateRoster">Validate</button>
            <button class="button is-medium is-warning" v-on:click="invalidateRoster">Invalidate</button>
            <button class="button is-medium is-default" v-on:click="clearRoster">Clear</button>
          </p>
        </div>
      </form>
    </article>
  </div>
</template>
<script>
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  components: {
    Notification
  },
  props: ['game_id', 'team_id', 'team_name', 'team_logo'],
  data () {
    return {
      Players: [],
      Team: [],
      cardModal: null,
      newModal: null,
      playerOptions: [],
      Roster: []
    }
  },
  computed: {
    sortByNumber: function () {
      return this.Players.slice().sort(function (a, b) {
        return (a.number - b.number)
      })
    }
  },
  methods: {

    fetchRoster () {
      this.$http.get('https://devilsapi.roblutken.com/api/games-played/get/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Roster = response.data
         // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, response => {
      })
    },
    fetchPlayers () {
      this.$http.get('https://devilsapi.roblutken.com/api/players/get/teams/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Players = response.data
        // console.log(this.Players)
        // this.playerOptions.push({text: '-', value: -1})
        this.playerOptions.push({text: 'Forwards', value: -2})
        for (var i of this.sortByNumber) {
          if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
            this.playerOptions.push({text: '#' + i.number + ' ' + i.surname, value: i.id})
          }
        }
        this.playerOptions.push({text: 'Defense', value: -2})
        for (var d of this.sortByNumber) {
          if (d.position === 'LD' || d.position === 'RD') {
            this.playerOptions.push({text: '#' + d.number + ' ' + d.surname, value: d.id})
          }
        }
        this.playerOptions.push({text: 'Goaltender', value: -2})
        for (var g of this.sortByNumber) {
          if (g.position === 'GT' || g.position === 'BKGT') {
            this.playerOptions.push({text: '#' + g.number + ' ' + g.surname, value: g.id})
          }
        }
      }, response => {
      })
    },
    updateRoster (_item, _newPlayer) {
      if (_item.player_id[0].id !== _newPlayer) {
        // console.log('Updated: ' + _item.player_id[0].id + ' TO player: ' + JSON.stringify(_newPlayer))
        /*eslint-disable */
        // eslint-disable-line no-use-before-define
        var formData = new FormData() // eslint-disable-line no-use-before-define
        formData.append('game_id', this.game_id)
        formData.append('team_id', this.team_id)
        formData.append('id', _item.id)
        formData.append('line_number', _item.line_number)
        formData.append('position', _item.position)
        formData.append('player_id', _newPlayer)

        this.$http.post('https://devilsapi.roblutken.com/api/games-played/update/',formData,{ headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'multipart/form-data' } }).then(
        response => {
          console.log(response.data)
          if (response.data.status === '202') {
            // openNotification({
            //   title: 'Update Success',
            //   message: response.data.message,
            //   type: 'success',
            //   duration: 400
            // })
          // this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
          } else {
            openNotification({
              title: 'Failed to update',
              message: response.data.message,
              type: 'danger',
              duration: 400
            })
            _newPlayer = ''
            // _item = ''
          }
        }, response => {
        })
        this.fetchRoster()
      /*eslint-enable*/
      }
    },
    clearRoster () {
      this.$http.get('https://devilsapi.roblutken.com/api/games-played/clear/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, response => {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        })
        this.fetchPlayers()
        this.fetchRoster()
      })
    },
    validateRoster () {
      this.$http.get('https://devilsapi.roblutken.com/api/games-played/validate/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, response => {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        })
        this.fetchPlayers()
        this.fetchRoster()
      })
    },
    invalidateRoster () {
      this.$http.get('https://devilsapi.roblutken.com/api/games-played/invalidate/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
       // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, response => {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        })
        this.fetchPlayers()
        this.fetchRoster()
      })
    },
    generateRoster () {
      this.$http.get('https://devilsapi.roblutken.com/api/games-played/clone/' + this.game_id + '/' + this.team_id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
       // console.log('Roster is: ' + JSON.stringify(this.Roster))
      }, response => {
        openNotification({
          title: 'Update Success',
          message: response.data.message,
          type: 'success',
          duration: 400
        })
        this.fetchPlayers()
        this.fetchRoster()
      })
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      })
    }
  },
  created: function () {
    // console.log('Edit roster Loaded with game id: ' + this.game_id)
    this.fetchPlayers()
    this.fetchRoster()
  },
  update: function () {
    this.fetchPlayers()
  }
}
</script>

<style  lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';
.small {
  font-size: 1em;
  display: inline-block;
}
.title {
    font-size: 23px;
    font-family: 'Coda', cursive;
    font-weight: 700;
    text-transform: uppercase;
}
.is-horizontal-center {
  justify-content: center;
}
.columns{
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: center;

}
.button {
  margin: 5px 0 0;
  // font-size: 1em;
  font-family: 'Coda', cursive;
  font-weight: 700;
  text-transform: uppercase;
 
}
.is-child.box.player:hover{
background-color: rgba(250, 250, 250, 0.678);
color: #00d1b2;
cursor: pointer;
}
.is-child.box:hover p{
color: #00d1b2;
cursor: pointer;
}
.team_logo {
  width: 120px;
  height:120px;
  margin-left:25px;
}
.control .button {
  margin: inherit;
}
.table thead td, .table thead th {
   font-size: 0.8em;
  font-family: 'Coda', cursive;
  font-weight: 400;
  text-transform: uppercase;
  color:black;
}
.select select{
  font-size: 0.8em;
  font-family: 'Coda', cursive;
  font-weight: 700;
  text-transform: uppercase;
}
.select{
   height:1.5em;
   font-size:16px;
}
.control.has-addons {
  @include mobile() {
    input {
      width: 100%;
    }

    input.is-expanded {
      flex-shrink: 1;
    }
  }
}
.colourdtd{
  background-color:black;
}
.verified{
  background-color: rgb(0, 100, 0);
  color:whitesmoke;
}
.unverified{
  background-color: rgb(255, 239, 239);
  color:black;
}
</style>



// WEBPACK FOOTER //
// edit-roster.vue?ac2b7518